export default __webpack_public_path__ + "static/coperta-raport-sust-a677cef5b780015b1bced6f9d9d69d0e.jpg";